<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
        <div style="page-break-inside: avoid">
            <h5>{{title}}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td>Terminal Type</td>
                    <td>Fuel(s)</td>
                </tr>
                <tr *ngFor="let t of terminals">
                    <td>{{t.terminalType}}</td>
                    <td>
                        <ul class="list-unstyled" style="margin-bottom:0px;">
                            <li *ngFor="let tf of t.terminalFuels" style="margin-top:2px;">
                                <span [hidden]="!tf.annualCapacity && !tf.material">
                                    {{tf.material}}: <span [hidden]="!tf.annualCapacity">{{tf.annualCapacity}}
                                        {{tf.annualRateUnit}}</span>
                                    <span [hidden]="tf.annualCapacity">unknown capacity</span><span
                                        [hidden]="!tf.processingUnitType">&nbsp;(Processing Unit:
                                        {{tf.processingUnitType}})</span>
                                </span>
                            </li>
                        </ul>
                    </td>
                </tr>
            </table>
        </div>
</ng-template>

<ng-template #template_mobile let-title="title">
        <div style="page-break-inside: avoid">
            <h5>{{title}}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td>Terminal Type</td>
                    <td>Fuel(s)</td>
                </tr>
                <tr *ngFor="let t of terminals">
                    <td>{{t.terminalType}}</td>
                    <td>
                        <ul class="list-unstyled" style="margin-bottom:0px;">
                            <li *ngFor="let tf of t.terminalFuels" style="margin-top:2px;">
                                <span [hidden]="!tf.annualCapacity && !tf.material">
                                    {{tf.material}}: <span [hidden]="!tf.annualCapacity">{{tf.annualCapacity}}
                                        {{tf.annualRateUnit}}</span>
                                    <span [hidden]="tf.annualCapacity">unknown capacity</span><span
                                        [hidden]="!tf.processingUnitType">&nbsp;(Processing Unit:
                                        {{tf.processingUnitType}})</span>
                                </span>
                            </li>
                        </ul>
                    </td>
                </tr>
            </table>
        </div>
</ng-template>